var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavigationBar',{attrs:{"data-test-id":"MtpNavigationBar","dropdownMenuTitle":_vm.dropdownMenuTitle,"locationLabel":_vm.locationLabel,"logoImg":_vm.logoImg,"menuSections":_vm.menuSections,"showJcLogo":_vm.showJcLogo}})
}
var staticRenderFns = []

export { render, staticRenderFns }